import styled from "styled-components";

export const PosterMakerWrapper = styled.div`
  width: calc(100% - 60px);
  height: calc(100vh - 108px);
  overflow-y: auto;

  display: flex;
  flex-direction: row;
  gap: 32px;

  padding: 50px 30px 58px;
`;

export const PosterMakerTitle = styled.div`
  color: #121212;
  font-family: Pretendard;
  font-size: 35px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
`;

export const PosterMakerLeftWrapper = styled.div`
  width: 854px;
  height: 972px;
  display: flex;
  flex-direction: column;
`;

export const PosterMakerRightWrapper = styled.div`
  width: 660px;
  height: 972px;
  display: flex;
  flex-direction: column;
  gap: 22px;
`;
